// @flow
import { REST_API_VERSION } from 'server-api-versioning';

export type RestRoute = {
	prefix: string,
	[string]: string,
}

export const restRoute: RestRoute = {
	api: 'api',
	prefix: 'rest',
	version: `v${REST_API_VERSION}`,
};

export const authRoute: RestRoute = {
	prefix: 'auth',
	tokens: 'tokens',
	links: 'links',
	esia: 'esia',
	physical: 'physical',
};

export const calcsRoute: RestRoute = {
	prefix: 'calcs',
	data: 'data',
	quotations: 'quotations',
	orders: 'orders',
};

export const lkRoute: RestRoute = {
	prefix: 'lk',
	data: 'data',
	profiles: 'profiles',
	my: 'my',
	policies: 'policies',
	active: 'active',
	registryOrders: 'registryOrders',
	terminationApplication: 'terminationApplication',
	physical: 'physical',
	juridical: 'juridical',
	documentTypes: 'documentTypes',
	esia: 'esia',
	bind: 'bind',
	emailVerification: 'emailVerification',
	send: 'send',
	print: 'print',
	last: 'last',
	orders: 'orders',
	fromPreviousOsago: 'fromPreviousOsago',
	osago: 'osago',
	resetPassword: 'resetPassword',
	register: 'register',
	eosago: 'eosago',
	PossibilityOfChangingPolicy: 'PossibilityOfChangingPolicy',
};

export const filesRoute: RestRoute = {
	prefix: 'files',
	persistent: 'persistent',
	temporary: 'temporary',
	download: 'download',
};

export const kladrRoute: RestRoute = {
	prefix: 'kladr',
	rsa: 'rsa',
	full: 'full',
	extended: 'extended',
	settlements: 'settlements',
	streets: 'streets',
	houses: 'houses',
};

export const datetimeRoute: RestRoute = {
	prefix: 'datetime',
	now: 'now',
};

export const vehicleRoute: RestRoute = {
	prefix: 'vehicles',
	data: 'data',
	types: 'types',
	usagePurposes: 'usagePurposes',
	documentTypes: 'documentTypes',
	ownershipConfirmationTypes: 'ownershipConfirmationTypes',
	transitReasons: 'transitReasons',
	models: 'models',
};

export const vehicleModelsRoute: RestRoute = {
	prefix: 'vehicleModels',
	transdekra: 'transdekra',
};

export const policiesRoute: RestRoute = {
	prefix: 'policies',
	activation: 'activation',
	property: 'property',
	summary: 'summary',
	gift: 'gift',
	dms: 'dms',
	multibox: 'multibox',
	vzr: 'travel',
};

export const officesRoute: RestRoute = {
	prefix: 'offices',
	all: 'all',
	getOfficesByCityNameAndRegionId: 'getOfficesByCityNameAndRegionID',
};

export const claimsRoute: RestRoute = {
	prefix: 'claims',
	cases: 'cases',
	data: 'data',
	phoneChecking: 'phoneChecking',
	send: 'send',
	verify: 'verify',
	juridical: 'juridical',
	services: 'services',
	order: 'order',
	update: 'update',
};

export const downTimeRoute: RestRoute = {
	prefix: 'info',
	downtime: 'sitedowntimes',
};

export const smsRoute: RestRoute = {
	prefix: 'sms',
	phoneChecking: 'phoneChecking',
	send: 'send',
	verify: 'verify',
};
export const dmsRoute: RestRoute = {
	prefix: 'dms',
	policies: 'policies',
	download: 'download',
};

export const massloadRoute = {
	prefix: 'massload',
	juridical: 'juridical',
	lists: 'lists',
	quotations: 'quotations',
	quotation: 'quotation',
	bills: 'bills',
	data: 'data',
	policy: 'policy',
	policies: 'policies',
	companies: 'companies',
	statuses: 'statuses',
	workflow: 'workflow',
	continue: 'continue',
	retry: 'retry',
	exclude: 'exclude',
	include: 'include',
	files: 'files',
	file: 'file',
	fileList: 'fileList',
	payment: 'payment',
	stop: 'stop',
	complete: 'complete',
	clone: 'clone',
	export: 'export',
	paymentCheck: 'paymentCheck',
	rejectPayment: 'rejectPayment',
	sendPaymentDocuments: 'waitPaymentConfirmedNonKey',
	confirmationPayment: 'paymentConfirmedNonKey',
	requests: 'requests',
	template: 'template',
	notifications: 'notifications',
	users: 'users',
	list: 'list',
	validation: 'validation',
	validate: 'validate',
	add: 'add',
	all: 'all',
	agents: 'agents',
	subAgents: 'sub-agents',
	remove: 'remove',
	status: 'status',
	update: 'update',
	count: 'count',
	changing: 'changing',
	changes: 'changes',
	clear: 'clear',
	insurer: 'insurer',
	create: 'create',
	temp: 'temp',
	addAll: `add-all`,
	available: 'available',
	premiumHistory: 'premium-history',
	termination: 'termination',
	reasons: 'reasons',
	cancel: 'cancel',
	terminate: 'terminate',
	confirmDocuments: 'confirmDocuments',
	rejectDocuments: 'rejectDocuments',
	signature: 'signature',
	archive: 'archive',
	sign: 'sign',
	deleteSignature: 'deleteSignature',
	drivers: 'drivers',
	delete: 'delete',
	apply: 'apply',
	reason: 'reason',
	vehicle: 'vehicle',
	act: 'act',
	cancelTermination: 'cancelTermination',
	awaitingBills: 'awaitingBills',
	awaitingTerminations: 'awaitingTerminations',
	tenders: 'tenders',
	blockings: 'blockings',
	checkCountPolicies: 'checkCountPolicies',
	checkInnInSkk: 'checkINNinSKK',
	managers: 'managers',
	managerContact: 'managerContact',
};


export const ordersRoute: RestRoute = {
	prefix: 'orders',
	status: 'status',
	payment: 'payment',
	repeat: 'repeat',
};
